var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { saveConnection, selectRangedTarget } from "../actions/actions";

class ActionButton extends Component {
  onClick(enabled, connection) {
    if (enabled) {
      if (this.props.action === 'save') {
        this.props.saveConnection(connection, this.props.onCreate);
      }
      if (this.props.action === 'connect') {
        this.props.selectRangedTarget(connection, this.props.onRangedConnect);
      }
    }
  }

  renderContent() {
    let buttonIcon = 'arrow-right';
    if (this.props.busy) {
      buttonIcon = 'spinner';
    }
    if (this.props.action === 'save') {
      buttonIcon = 'save';
      return /*#__PURE__*/_jsx(Translate, {}, void 0, "Save");
    }
    return /*#__PURE__*/_jsx(Icon, { icon: buttonIcon, spin: !!this.props.busy });
  }

  render() {
    const connection = this.props.connection.toJS();

    let connectionValid =
    connection.sourceDocument && connection.targetDocument && connection.template;

    if (this.props.type === 'basic') {
      delete connection.sourceRange;
    }

    if (this.props.type !== 'basic') {
      connectionValid = connectionValid && connection.sourceRange;
    }

    const enabled = connectionValid && !this.props.busy;
    const buttonClass =
    this.props.action === 'save' ? 'btn btn-success' : 'edit-metadata btn btn-success';

    return /*#__PURE__*/(
      _jsx("button", {
        className: buttonClass,
        disabled: !enabled,
        type: "button",
        onClick: this.onClick.bind(this, enabled, connection) }, void 0,

      this.renderContent()
      ));

  }
}

ActionButton.defaultProps = {
  onCreate: () => {},
  onRangedConnect: () => {},
  type: '',
  busy: false
};












function mapStateToProps({ connections }) {
  return {
    type: connections.connection.get('type'),
    connection: connections.connection,
    busy: connections.uiState.get('creating') || connections.uiState.get('connecting')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ saveConnection, selectRangedTarget }, dispatch);
}

export { ActionButton, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps)(ActionButton);